import type { Application, EngineerLinkage, EngineerMaster } from "../types";
import { canAccessSubcontractorStep } from "./subcontractor";

export function emptyEngineerLinkage(): EngineerLinkage {
  return {
    engineerMasterId: null,
    linkedAt: undefined,
  };
}

export function findEngineerMaster(masters: EngineerMaster[], id: string | null | undefined): EngineerMaster | undefined {
  const sid = String(id ?? "").trim();
  if (!sid) return undefined;
  return masters.find((x) => String(x.id ?? "").trim() === sid);
}

/** Master row is usable for assignment when identity fields are present. */
export function isEngineerMasterAssignable(m: EngineerMaster | undefined): boolean {
  if (!m) return false;
  const name = String(m.fullName ?? "").trim();
  const phone = String(m.phone ?? "").trim();
  return Boolean(name && phone);
}

export function isEngineerLinkageComplete(link: EngineerLinkage, master: EngineerMaster | undefined): boolean {
  const mid = String(link.engineerMasterId ?? "").trim();
  if (!mid || !isEngineerMasterAssignable(master)) return false;
  return true;
}

/** Same gate as subcontractor assignment (ICICI, MOU, bills) — adjust in one place if policy changes. */
export function canAssignEngineer(app: Application): boolean {
  return canAccessSubcontractorStep(app);
}
